export default {

  methods: {
    
    draw_Timeline() {    

      let st = this.timeline.styles

      let Timeline = this.canvasChart
      .append('g')
      .attr('transform', `translate(${0}, ${this.chart.height + .5})`)
      .style('font-family', 'roboto')

      // Week 
      Timeline
      .selectAll('line1')
      .data(this.timeline.week)
      .enter()
      .append('line')
      .attr('x1', d => d.sx).attr('y1', 0)
      .attr('x2', d => d.sx).attr('y2', 2)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)



      // Month 
      Timeline
      .selectAll('line2')
      .data(this.timeline.month)
      .enter()
      .append('line')
      .attr('x1', d => d.sx).attr('y1', 2)
      .attr('x2', d => d.sx).attr('y2', 5)
      .attr('stroke', '#bcbcbc')
      .attr('stroke-width', (d,i)=> i==0 ? 0 : .5)

      Timeline
      .selectAll('text2')
      .data(this.timeline.month)
      .enter()
      .append('text')
      .attr('x', d=> d.mx).attr('y', 9 + st.month.tSize*0.36)
      .attr('font-size', st.month.tSize).attr('fill', st.month.tColor)
      .attr('text-anchor', 'middle')
      .text(d => d.name)


    }, 

    
  }
}
